import { useLazyQuery } from "@apollo/client/react";
import { useMemo } from "react";

import {
  SEARCH_MANAGED_ENTITIES_GROUP_BY_TYPES,
  SEARCH_STACK_MANAGED_ENTITIES_GROUP_BY_TYPES,
} from "./gql";

const useIacManagementTypesGroups = (parentStackId?: string) => {
  const [
    accountLazyFetch,
    {
      data: accountData,
      previousData: accountPreviousData,
      loading: accountLoading,
      called: accountCalled,
    },
  ] = useLazyQuery(SEARCH_MANAGED_ENTITIES_GROUP_BY_TYPES);

  const [
    stackLazyFetch,
    {
      data: stackData,
      previousData: stackPreviousData,
      loading: stackLoading,
      called: stackCalled,
    },
  ] = useLazyQuery(SEARCH_STACK_MANAGED_ENTITIES_GROUP_BY_TYPES);

  const groups = useMemo(() => {
    if (parentStackId) {
      return (
        stackData?.stack?.searchManagedEntitiesGroupByTypes?.edges.map((edge) => edge.node) ||
        stackPreviousData?.stack?.searchManagedEntitiesGroupByTypes?.edges.map(
          (edge) => edge.node
        ) ||
        []
      );
    } else {
      return (
        accountData?.searchManagedEntitiesGroupByTypes?.edges.map((edge) => edge.node) ||
        accountPreviousData?.searchManagedEntitiesGroupByTypes?.edges.map((edge) => edge.node) ||
        []
      );
    }
  }, [
    accountData?.searchManagedEntitiesGroupByTypes?.edges,
    accountPreviousData?.searchManagedEntitiesGroupByTypes?.edges,
    parentStackId,
    stackData?.stack?.searchManagedEntitiesGroupByTypes?.edges,
    stackPreviousData?.stack?.searchManagedEntitiesGroupByTypes?.edges,
  ]);

  const accountDataIsEmpty =
    accountData &&
    "searchManagedEntitiesGroupByTypes" in accountData &&
    !groups.length &&
    !accountLoading;

  const stackDataIsEmpty = Boolean(
    stackData?.stack?.searchManagedEntitiesGroupByTypes && !groups.length && !stackLoading
  );

  const endCursor = parentStackId
    ? stackData?.stack?.searchManagedEntitiesGroupByTypes?.pageInfo.endCursor
    : accountData?.searchManagedEntitiesGroupByTypes?.pageInfo.endCursor;
  const startCursor = parentStackId
    ? stackData?.stack?.searchManagedEntitiesGroupByTypes?.pageInfo.startCursor
    : accountData?.searchManagedEntitiesGroupByTypes?.pageInfo.startCursor;

  return {
    lazyFetch: parentStackId ? stackLazyFetch : accountLazyFetch,
    groups,
    loading: parentStackId ? stackLoading : accountLoading,
    called: parentStackId ? stackCalled : accountCalled,
    endCursor,
    startCursor,
    dataIsEmpty: parentStackId ? stackDataIsEmpty : accountDataIsEmpty,
  };
};

export default useIacManagementTypesGroups;
